import axios from '@/plugin/axios'
import api from '@/api'

export const warranty = {
  fetchWarranyArticles
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data)
    }).catch(e => {
      if (e.code === 404 || e.message === 'Network Error') resolve({items: []} as any)
      else reject(e)
    })
  })
}

function fetchWarranyArticles(_region: string, _language: string): Promise<any> {
  const endpoint = api.endpoints.DPMM_API.WARRANTY_ARTICLES
    .replace('{region_code}', _region)
    .replace('{language}', _language)
  return promiseWrapper(axios.get(endpoint))
}
